<template>
  <div class="contact-mentor-form" v-if="mentor">
    <b-row class="py-3 border-bottom">
      <b-col cols="12" class="d-flex justify-content-center align-items-center">
        <avatar :user="mentor" :size="72"/>
      </b-col>
      <b-col cols="12" class="pt-3 text-center">
        <b>{{mentor.fullName}}</b><br>
        <span class="text-muted" v-if="jobTitle">{{jobTitle}}</span>
        <span class="text-muted pl-4" v-if="mentor.location">
          <font-awesome-icon icon="map-marker" style="color: #bbb"/> {{mentor.location.name}}
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="pt-3 pb-2">
        <b-form-group label="Selected skills" label-class="pb-0 mb-0">
          <span
            class="skill-tag mr-2 mt-2"
            v-for="skill in mentorRequest.skills"
            :style="{ backgroundColor: skillBG }"
            :key="skill"
          >{{ skill }}</span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          :label="`Personal message to ${mentor.firstName}`"
           label-class="pb-0 mb-0"
        >
          <div>{{ mentorRequest.message }}</div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="Status"
          label-class="pb-0 mb-0"
        >
          <div>{{ status }}</div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="actionButtons" class="mt-3">
      <b-col>
        <b-button
          class="ml-3 py-2 px-4 float-right"
          variant="success"
          @click="$emit('acceptRequest')"
        >
          Activate Mentorship
        </b-button>
        <b-button
          class="ml-3 py-2 px-4 float-right"
          variant="outline-danger"
          @click="$emit('rejectRequest')"
        >
          Decline Request
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Avatar from '@/components/users/Avatar';

export default {
  components: { Avatar },
  props: {
    mentor: {
      type: Object,
      default: null,
    },
    jobTitle: {
      type: String,
      default: '',
    },
    mentorRequest: {
      type: Object,
      default: null,
    },
    skills: {
      type: Array,
      default: () => [],
    },
    skillBG: {
      type: String,
      default: '#eee',
    },
    status: {
      type: String,
      default: '',
    },
    actionButtons: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.contact-mentor-form {
  .skill-tag {
    display: inline-block;
    font-size: 13px;
    padding: 3px 6px;
    border-radius: 2px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mentors/MentorRequestDetails.vue